module.exports = __webpack_public_path__ + "img/W@2x.94f7859.webp";